<ion-header>
  <ion-toolbar>
    <ion-title>
      {{ 'CHECK_CONNECTION.MODAL_TITLE' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content
  class="ion-padding"
  [fullscreen]="false"
  [ngStyle]="{ '--color': '#fff' }"
>
  <div
    class="page-container"
    [ngStyle]="{
      '--instance-color': _instance_color,
      '--instance-color-alpha': _instance_color_alpha
    }"
  >
    <div>
      <p class="intro">
        {{ 'CHECK_CONNECTION.INTRO_MESSAGE' | translate }}
      </p>

      <!-- Network Section -->
      <div class="check-item">
        <div class="label">
          <div
            class="label-icon"
            [ngClass]="{
              'label-icon-success': networkStatus === 'success',
              'label-icon-warning': networkStatus === 'fail'
            }"
          >
            <ion-icon
              name="wifi"
              [ngClass]="{
          'wifi-checking': checking,
        }"
            ></ion-icon>
          </div>
          <div class="label-text">
            <span> {{ 'CHECK_CONNECTION.ITEM_TITLE' | translate }} </span>
          </div>
          <ng-container [ngSwitch]="networkStatus">
            <ion-spinner
              *ngSwitchCase="'loading'"
              [ngStyle]="{ '--color': _instance_color }"
            ></ion-spinner>
            <ion-icon
              *ngSwitchCase="'success'"
              name="checkmark-circle-outline"
              class="success-icon"
            ></ion-icon>
            <ion-icon
              *ngSwitchCase="'fail'"
              name="warning-outline"
              class="warning-icon"
            ></ion-icon>
          </ng-container>
        </div>
      </div>
      <p
        *ngIf="
          !checking && (networkStatus === 'fail' || networkStatus === 'success')
        "
        class="info-msg"
        [ngClass]="{
          'info-msg': networkStatus === 'success',
          'error-msg': networkStatus === 'fail'
        }"
      >
        <ion-icon name="information-circle-outline"></ion-icon>
        {{ networkMessage }}
      </p>
      <div
        *ngIf="!(networkStatus === 'fail' || networkStatus === 'success')"
        class="empty-msg-placeholder"
      ></div>
    </div>
    <ion-footer class="ion-no-border ion-text-center">
      <ion-button
        shape="round"
        (click)="isChecked ? dismiss() : startCheck()"
        [disabled]="checking"
        [ngStyle]="{
          '--background': _instance_color,
          '--background-hover': _instance_color,
          '--background-focused': _instance_color,
          '--background-activated': _instance_color
        }"
      >
        {{
          (checking
            ? 'CHECK_CONNECTION.CHECKING'
            : isChecked
            ? 'OK'
            : 'CHECK_CONNECTION.BUTTON_START'
          ) | translate
        }}
      </ion-button>
      <ion-button
        shape="round"
        fill="clear"
        size="small"
        (click)="startCheck()"
        [disabled]="checking"
        *ngIf="isChecked"
        class="recheck-button"
        [ngStyle]="{ '--color': _instance_color }"
      >
        {{ 'CHECK_CONNECTION.BUTTON_RECHECK' | translate }}
      </ion-button>
    </ion-footer>
  </div>
</ion-content>
